import React, { useEffect, useState } from "react";
import Preloader from "../layout/preloader";
import axiosClient from "../api";
import Aos from "aos";
import "aos/dist/aos.css";
import { jsPDF } from "jspdf";

const ClaudeApiRequest = () => {
  const [data, setData] = useState(null);
  const [novelId, setNovelId] = useState();
  const [loadingGenerateNovel, setLoadingGenerateNovel] = useState(false);
  const [loadingGenerateMore, setLoadingGenerateMore] = useState(false);
  const [loadingDownloadNovel, setLoadingDownloadNovel] = useState(false);
  const [generateMoreCount, setGenerateMoreCount] = useState(0);
  const [error] = useState(null);
  const [novelData] = useState(null);

  useEffect(() => {
    Aos.init({
      easing: "ease-out-cubic",
      once: true,
      offset: 50,
    });
  }, []);

  //// generate novel
  function generateNovel(e) {
    setLoadingGenerateNovel(true);

    const success = document.getElementById("success");
    const button = document.getElementById("send_message");
    const failed = document.getElementById("failed");
    e.preventDefault();

    const formData = e.target;

    const prompt = `using the save the cats writing method, write a basic novel premise paragraph using the following:

      - Plot Twist: ${formData["plot"].value}
      - Main protaganist: ${formData["character_name"].value}
      - setting: ${formData["setting"].value}
      - protagonists goal: ${formData["protagonist_goal"].value}
      - who or what prevents this goal: ${formData["protagonist_barrier"].value}
      - how does the protagaonist solve this: ${formData["protagonist_solution"].value}
      - key side characters: ${formData["key_side_characters"].value}
      - what does the protagonist learn: ${formData["protagonist_lessons"].value}
      - Genre: ${formData["genre"].value}`;

    axiosClient
      .post("/claude/generateNovel", {
        prompt: prompt,
        userId: localStorage.getItem("userId"),
      })
      .then((res) => {
        success.classList.add("show");
        button.classList.add("show");
        failed.classList.remove("show");
        setData(res.data.message);
        setNovelId(res.data.novelId);
      })
      .catch((e) => {
        failed.classList.add("show");
        console.error("Error fetching data:", e);
      })
      .finally(() => setLoadingGenerateNovel(false));
  }

  function generateChapterAndSave() {
    setLoadingGenerateMore(true);

    const success = document.getElementById("success");
    const button = document.getElementById("send_message");
    const failed = document.getElementById("failed");

    axiosClient
      .post("/claude/generateChapterAndSave", {
        novelId: novelId,
        userId: localStorage.getItem("userId"),
      })
      .then((res) => {
        success.classList.add("show");
        button.classList.add("show");
        failed.classList.remove("show");
        setData(res.data.message);
      })
      .catch((e) => {
        failed.classList.add("show");
        console.error("Error fetching data:", e);
      })
      .finally(() => setLoadingGenerateMore(false));
  }

  function savePdf() {
    setLoadingDownloadNovel(true);

    const success = document.getElementById("success");
    const button = document.getElementById("send_message");
    const failed = document.getElementById("failed");

    axiosClient
      .post(
        "/pdf/generatePdf",
        { novelId: novelId, userId: localStorage.getItem("userId") },
        { responseType: "blob" }
      )
      .then((res) => {
        const contentDisposition =
          res.headers["content-disposition"] ||
          res.headers["Content-Disposition"];
        let filename = "Novel.pdf"; // Default filename
        if (contentDisposition) {
          console.log(contentDisposition);
          const filenameMatch = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/i
          );
          if (filenameMatch) {
            filename = filenameMatch[1].replace(/['"]/g, "");
          }
        }
        console.log(filename);
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename); // Specify the download file name
        document.body.appendChild(link);
        link.click();

        success.classList.add("show");
        button.classList.add("show");
        failed.classList.remove("show");
      })
      .catch((e) => {
        failed.classList.add("show");
        console.error("Error fetching data:", e);
      })
      .finally(() => setLoadingDownloadNovel(false));
  }

  /// generateMore function needs to use await promise?
  /** generateMore test push content **/

  function generateMore(e) {
    e.preventDefault();
    setLoadingGenerateNovel(true);

    const success = document.getElementById("success");
    const button = document.getElementById("generateMoreNovel");
    const failed = document.getElementById("failed");
    const formData = new FormData(e);
    const formDataEntries = Array.from(formData.entries());
    const formDataString = formDataEntries.reduce((acc, [key, value]) => {
      acc += `${key}: ${value}\n`;
      return acc;
    }, "");
    setData((prevData) =>
      prevData ? prevData + "\n" + formDataString : formDataString
    );

    const prompt = `write a 1 chapter novel using the save the cat writing method based on the premise information in ${novelData}`;
    //test
    axiosClient
      .post("/claude/generateNovel", { prompt })
      .then((res) => {
        success.classList.add("show");
        button.classList.add("show");
        failed.classList.remove("show");
        setData((prevData) => prevData + " " + res.data.message);
        setGenerateMoreCount((prevCount) => prevCount + 1);
      })
      .catch((e) => {
        failed.classList.add("show");
        console.error("Error fetching data:", e);
        success.classList.add("show");
        console.error("Success fetching data:", e);
      })
      .finally(() => setLoadingGenerateNovel(false));
  }

  return (
    <div className="container">
      <div className="row">
        <div
          className="col-lg-10 offset-lg-1"
          data-aos="fade-up"
          data-aos-once="true"
          data-aos-delay="200"
          data-aos-duration="1000"
          data-aos-easing="ease"
        >
          <p className="lead">Fill the below details to generate a novel.</p>

          <div className="contact_form_wrapper">
            <form
              name="contactForm"
              id="contact_form"
              className="form-border"
              onSubmit={generateNovel}
            >
              <div className="row">
                <div className="col-lg-6 mb10">
                  <div className="field-set">
                    <span className="d-label">Plot</span>
                    <input
                      type="text"
                      name="Plot"
                      id="plot"
                      className="form-control"
                      placeholder="Plot"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Character Name</span>
                    <input
                      type="text"
                      name="Character Name"
                      id="character_name"
                      className="form-control"
                      placeholder="Character Name"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Setting</span>
                    <input
                      type="text"
                      name="Setting"
                      id="setting"
                      className="form-control"
                      placeholder="Setting"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Protagonist Goal</span>
                    <input
                      type="text"
                      name="Protagonist Goal"
                      id="protagonist_goal"
                      className="form-control"
                      placeholder="Protagonist Goal"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Protagonist Barrier</span>
                    <input
                      type="text"
                      name="Protagonist Barrier"
                      id="protagonist_barrier"
                      className="form-control"
                      placeholder="Protagonist Barrier"
                    />
                  </div>
                </div>

                <div className="col-lg-6 mb10">
                  <div className="field-set">
                    <span className="d-label">Protagonist Solution</span>
                    <input
                      type="text"
                      name="Protagonist Solution"
                      id="protagonist_solution"
                      className="form-control"
                      placeholder="Protagonist Solution"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Key Side Characters</span>
                    <input
                      type="text"
                      name="Key Side Characters"
                      id="key_side_characters"
                      className="form-control"
                      placeholder="Key Side Characters"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Protagonist Lessons</span>
                    <input
                      type="text"
                      name="Protagonist Lessons"
                      id="protagonist_lessons"
                      className="form-control"
                      placeholder="Protagonist Lessons"
                    />
                  </div>

                  <div className="field-set">
                    <span className="d-label">Genre</span>
                    <input
                      type="text"
                      name="Genre"
                      id="genre"
                      className="form-control"
                      placeholder="Genre"
                    />
                  </div>
                </div>
                <div className="col-12">
                  <div id="success" className="hide">
                    Novel Generated
                  </div>
                  <div id="failed" className="hide">
                    Error Generating Novel
                  </div>
                  <div id="submit" className="mt30">
                    <button
                      disabled={loadingGenerateNovel || loadingGenerateMore || loadingDownloadNovel}
                      type="submit"
                      id="send_message"
                      className="btn-main"
                    >
                      {loadingGenerateNovel ? (
                        <div
                          style={{
                            width: "120.391px",
                            height: "28.770px",
                            position: "relative",
                          }}
                        >
                          {[...Array(8)].map((_, index) => (
                            <div
                              key={index}
                              style={{
                                width: "2px",
                                height: "2px",
                                background: "#000",
                                borderRadius: "50%",
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transformOrigin: "-6px -6px",
                                animation: "lds-roller 1.2s linear infinite",
                                animationDelay: `-${index * 0.036}s`,
                                transform: `rotate(${
                                  index * 45
                                }deg) translate(10px)`,
                              }}
                            ></div>
                          ))}
                        </div>
                      ) : (
                        "Generate Novel"
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      {false ? (
        <div>
          <Preloader />
        </div>
      ) : (
        <div>
          {data && (
            <div>
              <pre
                style={{
                  backgroundColor: "#000000",
                  border: "1px solid rgba(0, 0, 0, 0.2)",
                  borderRadius: "5px",
                  padding: "10px",
                  marginTop: "20px",
                  color: "#FFFFFF",
                  textAlign: "center",
                }}
              >
                {data.split(" ").map((word, index) => {
                  if (index > 0 && index % 20 === 0) {
                    return <br key={index} />;
                  }
                  return word + " ";
                })}
              </pre>
              {error && (
                <p style={{ color: "red", textAlign: "center" }}>{error}</p>
              )}

              {generateMoreCount < 12 ? (
                <div className="d-flex gap-5">
                  <button
                    disabled={loadingGenerateNovel || loadingGenerateMore || loadingDownloadNovel}
                    onClick={generateChapterAndSave}
                    id="generateMoreNovel"
                    className="btn-main"
                  >
                    {loadingGenerateMore ? (
                        <div
                            style={{
                              width: "120.391px",
                              height: "28.770px",
                              position: "relative",
                            }}
                        >
                          {[...Array(8)].map((_, index) => (
                              <div
                                  key={index}
                                  style={{
                                    width: "2px",
                                    height: "2px",
                                    background: "#000",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transformOrigin: "-6px -6px",
                                    animation: "lds-roller 1.2s linear infinite",
                                    animationDelay: `-${index * 0.036}s`,
                                    transform: `rotate(${
                                        index * 45
                                    }deg) translate(10px)`,
                                  }}
                              ></div>
                          ))}
                        </div>
                    ) : (
                        "Generate More Chapters"
                    )}
                  </button>
                  <button
                    disabled={loadingGenerateNovel || loadingGenerateMore || loadingDownloadNovel}
                    onClick={savePdf}
                    id="generateMoreNovel"
                    className="btn-main"
                  >
                    {loadingDownloadNovel ? (
                        <div
                            style={{
                              width: "120.391px",
                              height: "28.770px",
                              position: "relative",
                            }}
                        >
                          {[...Array(8)].map((_, index) => (
                              <div
                                  key={index}
                                  style={{
                                    width: "2px",
                                    height: "2px",
                                    background: "#000",
                                    borderRadius: "50%",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transformOrigin: "-6px -6px",
                                    animation: "lds-roller 1.2s linear infinite",
                                    animationDelay: `-${index * 0.036}s`,
                                    transform: `rotate(${
                                        index * 45
                                    }deg) translate(10px)`,
                                  }}
                              ></div>
                          ))}
                        </div>
                    ) : (
                        "Download Novel"
                    )}
                  </button>
                </div>
              ) : (
                <span></span>
              )}
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default ClaudeApiRequest;
